export class UpdateScreenRoomNumber {
  static readonly type = '[Reservation] Update Screen Room Number';
  constructor(public screenRoomNumber: number | null) {}
}
